import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MelbournesReliableSparkies() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38705" id="central-coast-plumbing-solutions" className="light bg-background text-foreground relative h-[90vh] w-full overflow-hidden flex flex-col items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581682/img/image_r8a2uwjh.png)] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-white/50 backdrop-blur-[1px] bg-gradient-to-b from-white/40 to-white/10" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="text-transparent bg-clip-text bg-gradient-to-br from-primary via-primary to-blue-400 font-extrabold text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[1.1] mb-8 drop-shadow-sm max-w-5xl">
          Reliable Plumbing Services on the Central Coast
        </h1>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-14 px-8 rounded-full font-bold shadow-xl shadow-primary/20 transition-transform hover:scale-105">
            <Link to="/ContactPage">
              Request a Quote
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="border-2 border-primary/20 text-primary bg-white/10 hover:bg-primary hover:text-white text-lg h-14 px-8 rounded-full font-bold transition-transform hover:scale-105 backdrop-blur-md">
            <Link to="tel:0417818188">
              <Phone className="mr-2 size-5" />
              Call 0417 818 188
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 w-full max-w-xs sm:max-w-md px-4 flex justify-center">
        
      </div>
    </section>;
}